import { AlertCircle, Check, CheckCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DeliveryStatus } from '@/Domain/api/Conversation/dto/Message.dto';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';

type Props = {
  status: DeliveryStatus;
  errorMessage?: string | null;
};

export const DeliveryStatusIndicator = ({ status, errorMessage }: Props) => {
  const { t } = useTranslation('inbox_v2');

  switch (status) {
    case 'sent':
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span data-testid="delivery-status-sent" className="inline-flex items-center">
              <Check className="h-3.5 w-3.5 text-foreground-subtle" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="bottom">{t('whatsapp_status_sent')}</TooltipContent>
        </Tooltip>
      );
    case 'delivered':
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span data-testid="delivery-status-delivered" className="inline-flex items-center">
              <CheckCheck className="h-3.5 w-3.5 text-foreground-subtle" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="bottom">{t('whatsapp_status_delivered')}</TooltipContent>
        </Tooltip>
      );
    case 'read':
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span data-testid="delivery-status-read" className="inline-flex items-center">
              <CheckCheck className="h-3.5 w-3.5 text-blue-500" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="bottom">{t('whatsapp_status_read')}</TooltipContent>
        </Tooltip>
      );
    case 'failed':
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span data-testid="delivery-status-failed" className="inline-flex items-center">
              <AlertCircle className="h-3.5 w-3.5 text-red-500" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            {errorMessage || t('whatsapp_status_failed')}
          </TooltipContent>
        </Tooltip>
      );
    default:
      return null;
  }
};
